/**
 * AERO E-shop - Main JavaScript Entry Point
 * Redesign 2025
 */

// Import Tailwind CSS (pro rychlé prototypování)
import '../css/tailwind.css';

// Import custom SCSS styles
import '../css/main.scss';

// Import modules
import { initBasket } from './modules/basket';
import { initSearch } from './modules/search';
import { initProductGrid } from './modules/product-grid';
import { initCatalogSwitcher } from './modules/catalog-switcher';
import { initSortBar } from './modules/sort-bar';
import { initLoginModal } from './modules/login-modal.js';

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  console.log('🚀 AERO E-shop initialized');

  // Initialize modules
  initBasket();
  initSearch();
  initProductGrid();
  initCatalogSwitcher();
  initSortBar();
  initLoginModal();

  // Hamburger menu (mobile navigation)
  const hamburgerBtns = [
    document.getElementById('hamburgerBtn'),
    document.getElementById('hamburgerBtnHeader')
  ].filter(Boolean);
  const mobileMenu = document.getElementById('mobileMenu');
  if (mobileMenu && hamburgerBtns.length) {
    hamburgerBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const isOpen = mobileMenu.classList.toggle('is-open');
        hamburgerBtns.forEach(b => b.setAttribute('aria-expanded', String(isOpen)));
      });
    });
    document.addEventListener('click', e => {
      if (!hamburgerBtns.some(b => b.contains(e.target)) && !mobileMenu.contains(e.target)) {
        mobileMenu.classList.remove('is-open');
        hamburgerBtns.forEach(b => b.setAttribute('aria-expanded', 'false'));
      }
    });
  }

  // Scroll to top button
  const scrollBtn = document.getElementById('scrollTopBtn');
  if (scrollBtn) {
    window.addEventListener('scroll', () => {
      scrollBtn.classList.toggle('is-visible', window.scrollY > 400);
    }, { passive: true });
    scrollBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // Log environment
  console.log('Environment:', {
    viteMode: import.meta.env.MODE,
    hmr: import.meta.hot !== undefined
  });
});

// Hot Module Replacement
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('🔥 HMR update');
  });
}
